import ScrollReveal from '@/components/ScrollReveal';
import { ShieldCheck, Clock, Zap, CalendarCheck, Receipt, Calendar } from 'lucide-react';

const REASONS = [
  { icon: Clock, title: '24–48 Hour Turnaround', desc: 'Your report guaranteed within 48 hours of the appointment — every time.' },
  { icon: CalendarCheck, title: 'Same-Day Booking', desc: 'Clerks available at four hours\' notice for unforeseen circumstances.' },
  { icon: ShieldCheck, title: 'Accredited Clerks', desc: 'AIIC-accredited, with supervisors reviewing every report for accuracy.' },
  { icon: Calendar, title: 'Open 7 Days a Week', desc: 'Office support every day, including bank holidays — queries never wait.' },
  { icon: Zap, title: 'Express Delivery', desc: 'On request — turnaround of your report within just 6 hours.' },
  { icon: Receipt, title: 'Transparent Accounting', desc: 'A full record of every report, ready for the end of your tax year.' },
];

export default function WhyChooseUs() {
  return (
    <section className="py-16 md:py-32 bg-navy text-white">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <ScrollReveal>
          <p className="caps-label text-orange mb-4">Why Daley</p>
          <h2 className="font-display font-extrabold mb-16" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
            More than an inventory company
          </h2>
        </ScrollReveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {REASONS.map((reason, i) => (
            <ScrollReveal key={reason.title} delay={i * 0.1}>
              <div>
                <reason.icon className="text-orange mb-6" size={32} />
                <h3 className="text-lg font-semibold mb-3">{reason.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{reason.desc}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}